/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from 'constants/Colors';
import {FontWeight, Text} from 'components/Text';
import {Breakpoints} from "../../../../constants/Breakpoints";
import {mediaHelper} from "../../../../utils/src";

const Content = styled.div`
  background-color: ${Colors.WHITE};
  border: 1px solid ${Colors.BLUE};
  margin: 0;
  border-radius: 10px
  box-shadow: 0px 17px 17px 6px #5f5f5f1a;
  
  @media screen and (min-width: ${Breakpoints.sm}) {
    margin-top: 40px;
    margin-bottom: 10%;
    border-radius: 15px;
  }
  
  ${mediaHelper.md`
    border-radius: 20px;
  `}
`;

const Heading = styled.div`
  background: ${Colors.BLUE};
  color: ${Colors.WHITE};
  padding: 6px 15px 6px 15px;
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 15px;
  border-radius: 10px 10px 0 0
  margin: -30px -10px 5px -10px;
  
  @media screen and (min-width: ${Breakpoints.sm}) {
    border-radius: 15px 15px 0px 0px;
  }
  
  ${mediaHelper.md`
    border-radius: 20px 20px 0 0;
  `}
`;


const TitleChart = styled(Text)`
  font-size: 16px;
  display: block;
  margin-top: 30px;
  margin-left: 10px
`;

const TitleCalendar = styled(Text)`
  font-size: 16px;
  display: block;
  margin-top: 30px;
  margin-left: 10px
  margin-bottom: 20px;
`;

const Legend = styled.div`
  height: 60px;

  .content{
    p{
      width: 50%;
      display: inline-block;
      font-size: 13px;
      color: #777;
    }
    p:first-child{
      text-align: right;
    }
    span{
      width: 10px;
      height: 10px;
      margin-right: 5px;
      display: inline-block;
      margin-left: 10px;
    }
  }
`;


export { Content, Heading, TitleChart, TitleCalendar, Legend };
